import Vue from 'vue';
import { getAppBaseConfig } from '@/storage/services/AppBaseConfigService'

    import axios from 'axios'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

export const DEMO_NAME = $t('22cee0')

const DEMO_ACCOUNT_LIST = ['18660000060', '18660000061']

// DEMO账号mapping
export const isEqualDemo = () => {
  const appBaseInfo = getAppBaseConfig()
  if (appBaseInfo && appBaseInfo.appName === 'hotelcem' && DEMO_ACCOUNT_LIST.includes(appBaseInfo.userInfo?.account)) {
    return true
  }
  return false
}

const replaceKeywords = str => {
  const keywords = [
    $t('3096ac'),
    $t('fc52d0'),
    $t('121daf'),
    $t('ed9bb3'),
    $t('aebe0b'),
    $t('8d67b3'),
    $t('e9119d'),
    $t('5b4363'),
    $t('373e7d'),
    $t('7aa071'),
  ]
  if (!str) {
    return str
  }
  let res = str
  for (const keyword of keywords) {
    const reg = new RegExp(keyword, 'g')
    res = res.replace(reg, DEMO_NAME)
  }
  return res
}

// 需要替换的接口地址
const APIList = {
  '/api/v1/xreports/cem/dataCube2/detailQuery'(data) {
    if (data) {
      for (const item of data.records) {
        item.value = replaceKeywords(item.value)
        if (item?.extraValues?.hotelName) {
          item.extraValues.hotelName = replaceKeywords(item.extraValues.hotelName)
        }
        if (item?.extraValues?.commentContent) {
          item.extraValues.commentContent = replaceKeywords(item.extraValues.commentContent)
        }
        if (item?.extraValues?.cubeCommentLabelList?.length) {
          for (const obj of item.extraValues.cubeCommentLabelList) {
            obj.labelContent = replaceKeywords(obj.labelContent)
          }
        }
      }
    }
    return data
  },
  '/api/v1/xreports/data-source/group/raw/data/list'(data) {
    if (data) {
      for (const arr of data.records) {
        for (const index in arr) {
          arr[index] = replaceKeywords(arr[index])
        }
      }
    }
    return data
  },
  '/api/v1/xreports/cem/complaint/list'(data) {
    if (data) {
      for (const item of data.records) {
        if (item.channelInfo) {
          item.channelInfo.hotelName = replaceKeywords(item.channelInfo.hotelName)
          if (item.channelInfo.asrInfo?.communicates?.length) {
            for (const communicate of item.channelInfo.asrInfo.communicates) {
              communicate.content = replaceKeywords(communicate.content)
            }
          }
        }
      }
    }
    return data
  },
  '/api/v1/xreports/cem/complaint/detail'(data) {
    if (data) {
      data.name = replaceKeywords(data.name)
      data.content = replaceKeywords(data.content)
    }
    return data
  },
  '/api/v1/xreports/cem/hotel/compete-analysis/competitor/detail/trend'(data) {
    if (data) {
      if (data.hotelRankInfoList?.length) {
        for (const item of data.hotelRankInfoList) {
          item.hotelName = replaceKeywords(item.hotelName)
        }
      }
    }
    return data
  },
  '/api/v1/xreports/cem/hotel/compete-analysis/competitor/detail'(data) {
    if (data) {
      if (data.competitorDetailList?.length) {
        for (const item of data.competitorDetailList) {
          item.hotelName = replaceKeywords(item.hotelName)
        }
      }
    }
    return data
  },
  '/api/v1/xreports/cem/hotel/user/hotel-list'(data) {
    if (data?.length) {
      for (const item of data) {
        item.cloudHotelName = replaceKeywords(item.cloudHotelName)
        item.ctripHotelName = replaceKeywords(item.ctripHotelName)
        item.hotelName = replaceKeywords(item.hotelName)
      }
    }
    return data
  },
  '/api/v1/xreports/cem/hotel/voice/demand/data/list'(data) {
    if (data?.records?.length) {
      for (const arr of data.records) {
        for (let i = 0; i < arr.length; i++) {
          arr[i] = replaceKeywords(arr[i])
        }
      }
    }
    return data
  },
  '/api/v1/xreports/cem/hotel/voice/repeat/voice'(data) {
    if (data?.records?.length) {
      for (const item of data.records) {
        item.content = replaceKeywords(item.content)
      }
    }
    return data
  },
  '/api/v1/xreports/cem/hotel/biz-area-rank-detail'(data) {
    if (data?.details?.length) {
      for (const item of data.details) {
        item.hotelName = replaceKeywords(item.hotelName)
      }
    }
    return data
  },
}

const responseFunc = response => {
  const { data, config } = response

  // 文本替换
  const baseUrl = config.baseURL ? config.baseURL : ''
  const key = baseUrl.replace(process.env.VUE_APP_APIBASEURL, '') + config.url
  if (isEqualDemo() && data) {
    if (APIList[key]) {
      data.data = APIList[key](data.data)
    } else if (config.method.toUpperCase() === 'GET') {
      const arr = key.split('?')
      if (arr && arr[0]) {
        APIList[arr[0]] && APIList[arr[0]](data.data)
      }
    }
  }

  return response
}

const responseError = error => {
  return Promise.reject(error)
}
// 添加响应拦截器
axios.interceptors.response.use(responseFunc, responseError)
